import React, { useState } from 'react';
import {
  Container, Row, Col, Form, InputGroup, Button,
  Table, Badge, Card, Dropdown, Modal
} from 'react-bootstrap';
import {
  Search, Eye, TrendingUp, DollarSign, Heart, Calendar
} from 'lucide-react';
import DonorLayout from '../../../layouts/donor/DonorLayout';
import '../../../assets/css/donor/dashboard/DonationHistory.css';

const DonationHistory = () => {

  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedDonation, setSelectedDonation] = useState(null);

  const donations = [
    { id: 1001, donorName: 'Ayaan Ahmed', amount: 12000, status: 'Completed', date: '21-Jan-2026', studentName: 'Ali khan', ngoName: 'EduCare NGO', method: 'Card', caseType: 'Fee Support' },
    { id: 1002, donorName: 'Sania Khan', amount: 15000, status: 'Completed', date: '20-Jan-2026', studentName: 'Sara Ahmad', ngoName: 'Knowledge Foundation', method: 'Wallet', caseType: 'Book Support' },
    { id: 1003, donorName: 'Faizan Malik', amount: 10000, status: 'Completed', date: '19-Jan-2026', studentName: 'Ahmed Raza', ngoName: 'Future Builders', method: 'Bank Transfer', caseType: 'Uniform Support' },
    { id: 1004, donorName: 'Ayaan Ahmed', amount: 8000, status: 'Pending', date: '18-Jan-2026', studentName: 'Fatima Noor', ngoName: 'Tech Education NGO', method: 'Wallet', caseType: 'Laptop Support' }
  ];

  const totalDonations = donations.reduce((sum, d) => sum + d.amount, 0);

  const handleViewDetails = (id) => {
    const donation = donations.find(d => d.id === id);
    setSelectedDonation(donation);
    setShowModal(true);
  };

  return (
    <DonorLayout>
      <div className="donation-history-container">
        <Container fluid>

          {/* ✅ TOP NAVY HEADER */}
          <Row>
            <Col>
              <div className="donation-history-top-banner">
                <h1>DONATION HISTORY</h1>
                <p>Track your donations and impact</p>
              </div>
            </Col>
          </Row>

          {/* SEARCH */}
          <Row className="mb-4">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text><Search size={18} /></InputGroup.Text>
                <Form.Control
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </Col>

            <Col md={6} className="text-end">
              <h5>Total: PKR {totalDonations.toLocaleString()}</h5>
            </Col>
          </Row>

          {/* ✅ TABLE ONLY (NO APPROVED HEADER) */}
          <div className="donation-history-table-wrapper">
            <Table responsive hover className="donation-history-table">

              <thead className="donation-history-thead">
                <tr>
                  <th>#</th>
                  <th>Donor</th>
                  <th>Student</th>
                  <th>NGO</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Method</th>
                  <th>Case Type</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {donations.map((d, i) => (
                  <tr key={d.id}>
                    <td>{i + 1}</td>
                    <td>{d.donorName}</td>
                    <td>{d.studentName}</td>
                    <td>{d.ngoName}</td>
                    <td>PKR {d.amount.toLocaleString()}</td>

                    <td>
                      <Badge bg={d.status === 'Completed' ? 'success' : 'warning'}>
                        {d.status}
                      </Badge>
                    </td>

                    <td>{d.method}</td>
                    <td>{d.caseType}</td>
                    <td>{d.date}</td>

                    <td>
                      <Button
                        className="donation-history-view-btn"
                        size="sm"
                        onClick={() => handleViewDetails(d.id)}
                      >
                        <Eye size={16} /> View
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>

            </Table>
          </div>

          {/* MODAL */}
          <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Donation Details</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {selectedDonation && (
                <>
                  <p><strong>ID:</strong> {selectedDonation.id}</p>
                  <p><strong>Amount:</strong> PKR {selectedDonation.amount}</p>
                  <p><strong>Status:</strong> {selectedDonation.status}</p>
                  <p><strong>Method:</strong> {selectedDonation.method}</p>
                </>
              )}
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={() => setShowModal(false)}>Close</Button>
            </Modal.Footer>
          </Modal>

          {/* SUMMARY */}
          <Row className="mt-4">
            <Col>
              <Card>
                <Card.Body>
                  <h4><TrendingUp size={18} /> Summary</h4>
                  <Row className="mt-3">
                    <Col md={4}>
                      <h5>PKR {totalDonations.toLocaleString()}</h5>
                      <p>Total Donation</p>
                    </Col>
                    <Col md={4}>
                      <h5>{donations.length}</h5>
                      <p>Donations</p>
                    </Col>
                    <Col md={4}>
                      <h5>2026</h5>
                      <p>Last Activity</p>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>
    </DonorLayout>
  );
};

export default DonationHistory;